import { createContext, useContext } from 'react';

type IsDisabledContextType = boolean;

export const IsDisabledContext = createContext<IsDisabledContextType>(false);

export const useIsDisabledContext = (): boolean => useContext<IsDisabledContextType>(IsDisabledContext);
